'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/registrations/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/schools/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/person/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _immutable = require('immutable');

var _ifeisIsomorphic = require('ifeis-isomorphic');

exports.default = function (school_id, feis_id, credit_card_fee) {
  return function (state) {

    if ((0, _paths3.schoolCompetitorsAreLoading)(state, school_id)) {
      return { loading: true, competitors: [] };
    }

    var loading = false;
    var competitors = (0, _paths3.getSchoolCompetitors)(state, school_id).filter(function (pid) {
      return (0, _paths5.getFlagsForPerson)(state, feis_id, pid).getIn(['registered']);
    }).filter(function (pid) {
      if ((0, _paths.registrationsForPersonAreLoading)(state, feis_id, pid)) {
        loading = true;
        return false;
      }
      return true;
    }).map(function (pid) {
      return (0, _paths4.getPerson)(state, pid);
    }).map(function (competitor) {
      var accountId = (0, _paths5.getFlagsForPerson)(state, feis_id, competitor.getIn(['id'])).getIn(['accountId']);
      var balance = state.getIn(['feiseanna', 'carts', feis_id, 'accounts', accountId, 'balance']) || 0;
      var paidFeisFee = state.getIn(['feiseanna', 'carts', feis_id, 'accounts', accountId, 'paidFeisFee']) || 0;
      var numParticipants = state.getIn(['feiseanna', 'carts', feis_id, 'accounts', accountId, 'numParticipants']) || 0;
      var estimatedCreditCardFee = 0;

      if (balance > 0) {
        estimatedCreditCardFee = (0, _ifeisIsomorphic.calculateCreditCardFee)(balance, credit_card_fee);
      }

      var totalBalance = balance + estimatedCreditCardFee || 0;

      return {
        competitor: competitor.toJS(),
        balance: balance,
        paidFeisFee: paidFeisFee,
        numParticipants: numParticipants,
        creditCardFee: estimatedCreditCardFee,
        totalBalance: totalBalance,
        accountId: accountId,
        registrations: (0, _paths.getRegistrationsForPerson)(state, feis_id, competitor.getIn(['id'])).toJS().map(function (id) {
          return (0, _paths2.getEvent)(state, id).toJS();
        })
      };
    }).toJS();

    return { loading: loading, competitors: competitors, totalPayment: 0.0 };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/registrations-for-school/mapStateToController.js
// module id = 593
// module chunks = 0